

import { lineString, featureCollection } from '@turf/helpers'
import { point as TurfPoint } from '@turf/helpers';
import lodashGet from 'lodash.get';

// const { KalmanFilter } = require('kalman-filter');

const lineTypes = {
  1: '#474B6D',
  2: '#474B6D',
  3: '#474B6D'
};

const REGULAR_COLOR = '#474B6D';

//path = _source.blockchain_id
const filterDuplicatesArrayByKey = (data, path) => {
  // Отфильтровать транзакции на наличие дубликатов
  const output = [];
  for (let dataItem of data) {
    // Fix this
    const findResult = output.find(
      (item) => lodashGet(item, path) === lodashGet(dataItem, path)
    );
    if (!findResult) {
      output.push(dataItem);
    }
  }
  return output;
}

/*
* Fix longitude antimeridian cutting
* https://macwright.com/2016/09/26/the-180th-meridian.html
* https://github.com/mapbox/mapbox-gl-js/issues/3250#issuecomment-294887678
* https://gis.stackexchange.com/questions/263639/leaflet-mapbox-issue-of-poly-line-which-crosses-the-international-dateline
*/

const fixAntimeridianCutting = (transactions) => {
  let copyList = JSON.parse(JSON.stringify(transactions));
  let prevLng;
  copyList = copyList.map((tx) => {
    let lng = tx._source.location.lg;
    if (prevLng) {
      lng += lng - prevLng > 180 ? -360 :
        prevLng - lng > 180 ? 360 : 0;
      tx._source.location.lg = lng;
    }
    prevLng = lng;
    return tx;
  });

  return copyList;
}



const validateGeoCoordinates = (transactions) => {
  let copyList = JSON.parse(JSON.stringify(transactions));
  let prevLng;
  // filter points without location and with wrong lat/lng
  copyList = copyList.filter(tx => {
    if (!tx._source.location || !Object.keys(tx._source.location).length) {
      return false;
    }
    let lng = tx._source.location.lg;
    if (prevLng) {
      lng += lng - prevLng > 180 ? -360 :
        prevLng - lng > 180 ? 360 : 0;
    }
    prevLng = lng;
    const lat = tx._source.location.lt;
    if (lng == null || typeof lng === 'undefined' || lat == null || typeof lat === 'undefined') {
      return false;
    }
    if (lat > -90 && lat < 90) {
      return true;
    }
    return false;
  })

  return copyList;
}

// const applyKalmanFilterv1 = (transactions) => {
//   const kflg = new KalmanFilter();
//   const kflt = new KalmanFilter();
//   for (const tx of transactions) {
//     const { lg, lt } = tx._source.location;
//     if (lg) {
//       tx._source.location.lg = kflg.filter(lg);
//     }
//     if (lt) {
//       tx._source.location.lt = kflt.filter(lt);
//     }
//   }
//   return transactions;
// }

// const applyKalmanFilterv2 = (transactions) => {
//   const coords = []
//   for (const tx of transactions) {
//     const { lg, lt } = tx._source.location;
//     coords.push([lg, lt]);
//   }

//   const kFilter = new KalmanFilter({ observation: 2 });
//   const res = kFilter.filterAll(coords);

//   for (let i = 0; i < res.length; i++) {
//     const resItem = res[i];
//     transactions[i]._source.location.lg = resItem[0];
//     transactions[i]._source.location.lt = resItem[1];
//   }
//   return transactions;
// }


const cleanData = (transactions) => {
  let output = transactions;
  // output = applyKalmanFilterv2(output);
  output = filterDuplicatesArrayByKey(output, '_id');
  output = validateGeoCoordinates(output);
  output = fixAntimeridianCutting(output);
  return output;
}

const _prepareLineGeoJSON = (transactions, id) => {
  const features = [];
  let coords = [];
  const length = transactions.length;  
  for (let i = 0; i < length; i++) {
    const tx = transactions[i];

    const { lt: lat, lg: lng } = tx._source.location;
    coords.push([lng, lat]);

    // Если у нас следующая точка содержит алерт,
    // то нужно линию, идущую к ней, преисполнить в цвет алерта 
    if (i != length - 1) {
      const { lt: nextLat, lg: nextLng } = transactions[i + 1]._source.location
      const nextAlerts = transactions[i + 1]._source.events;
      // По типу поймем в какой цвет красить алерт
      const type = transactions[i + 1]._source.alertMaxSeverity;
      if (nextAlerts && nextAlerts.length) {
        const coloredLineFeature = lineString([
          ...[coords[coords.length - 1]],
          ...[[nextLng, nextLat]]
        ], { color: lineTypes[type] });

        features.push(coloredLineFeature);

        if (coords.length > 1) {
          const lineFeature = lineString(coords, { color: REGULAR_COLOR })
          features.push(lineFeature);
        }
        coords = [];
      }
    }
  }

  if (coords.length && coords.length > 1) {
    const lineFeature = lineString(coords, { color: REGULAR_COLOR });
    features.push(lineFeature);
  }

  return featureCollection(features, { id });
}


const prepareMarkersPointsFeature = (trackPoints) => {
  // const output = applyKalmanFilterv2(trackPoints);
  const pointFeatures = [];
  for (const sample of trackPoints) {
    if (!sample._source) {
      continue;
    }
    const foundPoint = pointFeatures.find((point) => {
      return point.properties.id === sample._source.blockchain_id;
    });

    if (foundPoint) {
      continue;
    }
    const { lg, lt } = sample._source.location;
    const point = TurfPoint([lg, lt], {
      iconSize: [40, 40],
      _id: sample._id,
      id: sample._source.blockchain_id,
      source: sample._source,
    });
    pointFeatures.push(point);
  }
  
  return pointFeatures;
}


export {
  _prepareLineGeoJSON,
  filterDuplicatesArrayByKey,
  fixAntimeridianCutting,
  validateGeoCoordinates,
  cleanData,
  prepareMarkersPointsFeature
}
